import CloseRounded from '@mui/icons-material/CloseRounded';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type SaveAssetDialogTitleProps = {
  title: string;
  subtitle?: string;
  onClose: () => void;
  actions?: React.ReactNode;
};

export function SaveAssetDialogTitle({ title, subtitle, onClose, actions }: SaveAssetDialogTitleProps) {
  return (
    <DialogTitle>
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
        <Stack direction="column" alignItems="flex-start">
          <Typography variant="h6">{title}</Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Stack>
        <Stack direction="row" gap={2} alignItems="center">
          {actions}
          <IconButton aria-label="close" onClick={onClose}>
            <CloseRounded />
          </IconButton>
        </Stack>
      </Stack>
    </DialogTitle>
  );
}
